import { render, staticRenderFns } from "./ClientBankAccountRow.vue?vue&type=template&id=81519896&"
import script from "./ClientBankAccountRow.vue?vue&type=script&lang=js&"
export * from "./ClientBankAccountRow.vue?vue&type=script&lang=js&"
import style0 from "./ClientBankAccountRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports